import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Validation } from "../../../../domain/validation/Validation";
import { Card, Divider, Stack } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
} from "../../../../data/colors/Colors";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import AutoHeight from "../../../component/AutoHeightView";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomTextField } from "../../../component/CustomTextField";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { EmailRounded, LockRounded } from "@mui/icons-material";

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
}

function LoginForm({ onSubmit }: LoginFormProps) {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (email: string) => {
    setEmail(email);
  };

  const handlePasswordChange = (password: string) => {
    setPassword(password);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errors = validateInputs();
    setErrors(errors);

    if (Object.keys(errors).length === 0) onSubmit(email, password);
  };

  const validateInputs = () => {
    const errors: { [key: string]: string } = {};
    const emailValid = Validation.validateEmail(email);
    if (emailValid !== true) {
      errors.email = "Email not valid";
    }
    if (email.length === 0) {
      errors.email = "Please enter your email";
    }
    if (password.length === 0) {
      errors.password = "Please enter your password";
    }
    return errors;
  };

  const { width } = useWindowDimensions();

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      noValidate
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Card
        elevation={0}
        sx={{
          flex: 1,
          padding: "1.5rem",
          margin: "1.5rem",
          borderRadius: 8,
          minWidth: "25vw",
          width: "100%",
          backgroundColor: "white",
          minHeight: "65vh",
          display: "flex",
          alignItems: "center",
          background: COLOR_VERY_LIGHT_GRAY,
        }}
      >
        <Stack spacing={8} flex={1}>
          <CustomTextView
            text="Login"
            variant={width < 700 ? "h3" : "h4"}
            fontWeight="bold"
            textColor={COLOR_MAIN}
          />

          <Stack spacing={1}>
            <AutoHeight>
              <Box sx={{ p: 1 }}>
                <CustomTextField
                  type="email"
                  placeholder="Email"
                  isFullWidth
                  onTextChange={handleEmailChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  startIcon={<EmailRounded sx={{ color: COLOR_MAIN }} />}
                  textColor={COLOR_BLACK}
                  required
                  onHoverBorderColor={COLOR_LIGHT_GRAY}
                  onFocusBorderColor={COLOR_LIGHT_GRAY}
                  borderColor={COLOR_MAIN}
                  backgroundColor={"white"}
                />
              </Box>
            </AutoHeight>
            <AutoHeight>
              <Box sx={{ p: 1 }}>
                <CustomTextField
                  type="password"
                  placeholder="Password"
                  isFullWidth
                  onTextChange={handlePasswordChange}
                  error={!!errors.password}
                  helperText={errors.password}
                  required
                  startIcon={<LockRounded sx={{ color: COLOR_MAIN }} />}
                  textColor={COLOR_BLACK}
                  onHoverBorderColor={COLOR_LIGHT_GRAY}
                  onFocusBorderColor={COLOR_LIGHT_GRAY}
                  borderColor={COLOR_MAIN}
                  backgroundColor={"white"}
                />
              </Box>
            </AutoHeight>

            <CustomButtonView
              text="Login"
              type="submit"
              props={{ padding: 1 }}
            />
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
}

export default LoginForm;
